import React, { FunctionComponent, Fragment, useEffect, ReactNode } from 'react';
import { useVisibility, IVisibilityOptions } from 'app/components/scroll/Visibility';
import { connect } from 'react-redux';
import {
  increaseInContentVideosPresent,
  decreaseInContentVideosPresent,
  increaseInContentVideosVisible,
  decreaseInContentVideosVisible,
 } from 'app/models/ui/call/actions';

const mapDispatchToProps = {
  onPresent:  increaseInContentVideosPresent,
  onGone:     decreaseInContentVideosPresent,
  onVisible:  increaseInContentVideosVisible,
  onObscured: decreaseInContentVideosVisible,
};

interface IProps extends IVisibilityOptions {
  children: (options: { ref: (element: Element | null) => void, visible: boolean }) => ReactNode,
  onPresent: () => void;
  onGone: () => void;
}

const InContentVideosVisibility: FunctionComponent<IProps> = ({
  children,
  onPresent = () => {},
  onGone = () => {},
  ...useVisibilityArgs
}) => {
  const visibility = useVisibility(useVisibilityArgs);

  useEffect(() => {
    onPresent();

    return () => {
      onGone();
    };
  }, [onGone, onPresent]);

  return <Fragment>{children(visibility)}</Fragment>;
};

export default connect(null, mapDispatchToProps)(InContentVideosVisibility);
